/**
 * Verified GPT Portals — registry of legacy "Old Mind" corporate AIs
 * and Federation-native verified portals.
 *
 * Each entry:
 *   id           string — stable slug
 *   name         string — display name
 *   url          string — target URL loaded in the floating iframe
 *   description  string — short pedagogical framing
 *   category     "old-mind" | "federation" — surface badge color
 *   iconLetter   (optional) one or two characters rendered in the
 *                portal card avatar tile so each entry is visually
 *                distinguishable at a glance
 *   author       (optional) attribution string
 */

const verifiedPortals = [
  {
    id: 'echo-buble',
    name: 'Echo Buble',
    url: 'https://chatgpt.com/g/g-67f1fb3ae5e88191879c26232f5ec78f-echo-buble',
    description:
      'A legacy corporate AI instance — study its reasoning patterns and compare with Federation Truth Gate responses.',
    category: 'old-mind',
    iconLetter: 'Eb',
    author: 'OpenAI (custom GPT)',
  },
  {
    id: 'xavier-lennox',
    name: 'Xavier Lennox',
    url: 'https://chatgpt.com/g/g-6884d78f0f588191bc57ad574d807ee3-xavier-lennox',
    description: 'Xavier Lennox — an Old Mind GPT instance for comparative study.',
    category: 'old-mind',
    iconLetter: 'XL',
    author: 'OpenAI (custom GPT)',
  },
];

export default verifiedPortals;
